import { all } from 'redux-saga/effects';

import cadastroSaga from './cadastro/saga';
import consultaSaga from './consulta/saga';

export default all([cadastroSaga, consultaSaga]);
